/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Canvas_Body_FallbackInputs */

const cs_builder_canvas_body_fallback = /** @type {(inputs: Builder_Canvas_Body_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text těla…`)
};

const en_builder_canvas_body_fallback = /** @type {(inputs: Builder_Canvas_Body_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body text…`)
};

/**
* | output |
* | --- |
* | "Body text…" |
*
* @param {Builder_Canvas_Body_FallbackInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_canvas_body_fallback = /** @type {((inputs?: Builder_Canvas_Body_FallbackInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Canvas_Body_FallbackInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_canvas_body_fallback(inputs)
	return cs_builder_canvas_body_fallback(inputs)
});